import { Tabs } from '@mantine/core'

import classes from '../assets/css/components/CardWithTabs.module.css'
import { generateUUID } from '../utils/display'
import DataParam from './DataParam'
import Loader from './Loader'

interface CardWithTabsProps {
  className?: string
  title?: string
  tabs: {
    title: string
    value: string
    latest: number
    oldest?: number
    qty: string
    isLoading: boolean
    children?: React.ReactNode
    disabled?: boolean
  }[]
}

function CardWithTabs({ className, title, tabs }: CardWithTabsProps) {
  const tabWithoutChildren = tabs.filter((tab) => tab.children === undefined)
  const tabWithChildren = tabs.filter((tab) => tab.children !== undefined)
  return (
    <div className={`${className} bg-white p-0 relative border-t-[3px] border-[#001E61]`}>
      {title !== '' && <div className='text-base text-[#001E61] font-semibold mb-4 pt-4 pr-4 pl-4'>{title}</div>}
      <Tabs color='#001E61' defaultValue={tabWithChildren[0].value} inverted>
        <Tabs.List grow>
          {tabWithoutChildren.map((tab) => (
            <div key={generateUUID()} className='grow border-t-[3px] px-4 py-[10px]'>
              <div className='flex flex-col items-center pt-[6px]'>
                <div className='text-base text-[#001E61] font-semibold'>{tab.title}</div>
                <DataParam latest={tab.latest} oldest={tab.oldest} qty={tab.qty} />
              </div>
            </div>
          ))}

          {tabWithoutChildren.length > 0 && (
            <div className='flex items-center'>
              <div className='w-3 h-12 border-[#001E61] border-r-[3px]' />
            </div>
          )}

          {tabWithChildren.map((tab) => (
            <Tabs.Tab className={classes.tab} key={generateUUID()} value={tab.value} disabled={tab.disabled}>
              <div className='pt-[6px] flex flex-col items-center'>
                <div className='text-base text-[#001E61] font-semibold'>{tab.title}</div>
                <DataParam latest={tab.latest} oldest={tab.oldest} qty={tab.qty} />
              </div>
            </Tabs.Tab>
          ))}
        </Tabs.List>
        {tabWithChildren.map((tab) => (
          <Tabs.Panel className='relative p-4' key={generateUUID()} value={tab.value}>
            <Loader visible={tab.isLoading} />
            <div className='px-8 pt-4 pb-8'>
              {tab.isLoading ? <div className='w-full min-h-[33vh]' /> : tab.children}
            </div>
          </Tabs.Panel>
        ))}
      </Tabs>
    </div>
  )
}

CardWithTabs.defaultProps = {
  className: '',
  title: ''
}

export default CardWithTabs
